import { render, staticRenderFns } from "./AkinonShowDiscountCodes.vue?vue&type=template&id=bcb663e4"
import script from "./AkinonShowDiscountCodes.vue?vue&type=script&lang=js"
export * from "./AkinonShowDiscountCodes.vue?vue&type=script&lang=js"
import style0 from "./AkinonShowDiscountCodes.vue?vue&type=style&index=0&id=bcb663e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports